export const experiences = [
  {
    designation: "Junior Frontend Software Developer",
    company: "iBOS Limited, a concern of AKIJ Group",
    duration: "October, 2022 - Present",
    responsibilities: [
      "Expertly collaborated with managers, designers, and developers to develop impactful B2B solutions including Peopledesk- HR management, recruitment system.",
      "Created user interfaces with advanced business functions using technologies like JavaScript, React.js, Redux, typescript, etc. Utilized design libraries and frameworks to develop user-friendly solutions.",
    ],
  },
  {
    designation: "React Developer Intern",
    company: "Soft Solvers Solutions, Cyberjaya, Malaysia (Remote)",
    duration: "March, 2022 - September, 2022",
    responsibilities: [
      "Collaborated with managers, designers, and developers to transform a CRM business into robust software for insurance",
      "Created user interface with dynamic functionalities using technologies like JavaScript, React, Redux, Tachyons, MUI, typescript, etc.",
    ],
  },
];
